import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import CloseIcon from '@material-ui/icons/Close';
import VisibilityIcon from '@material-ui/icons/Visibility'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'

import api from "../../../api/backend"
import confirm from '../../confirm'

const DialogTitle = withStyles(theme => ({
    root: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        margin: 0,
        padding: theme.spacing.unit * 2,
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing.unit,
        top: theme.spacing.unit,
        color: theme.palette.grey[500],
    },
}))(props => {
    const { children, classes, onClose } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root}>
            <Typography variant="title">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="Close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles(theme => ({
    root: {
        margin: 0,
        padding: theme.spacing.unit * 2,
    },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
    root: {
        borderTop: `1px solid ${theme.palette.divider}`,
        margin: 0,
        padding: theme.spacing.unit,
    },
}))(MuiDialogActions);

class Editor extends Component {
    state = {
        open: false, departmentId: '', level: '', subjectNo: '', title: '', description: '', departments: []
    };

    handleClickOpen = () => {
        this.getDepartments()
        this.setState({ open: true })
    }

    handleClose = () => {
        this.setState({ open: false })
    }

    getDepartments = () => {
        api.getDepartments().then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                this.setState({ departments: json })
            }
        }).catch(() => { })
    }

    updateSubject = () => {
        const { subject } = this.props
        const { title, description, level, subjectNo, departmentId } = this.state
        api.updateSubject(subject.id, { title, description, level, subjectNo, departmentId }).then(([response, json]) => {
            if (response.status === 200) {
                this.setState({ open: false })
                if (this.props.onUpdateCompleted) {
                    this.props.onUpdateCompleted()
                }
            } else {
                console.error('ไม่สามารถบันทึกวิชาได้')
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
        })
    }

    deleteSubject = () => {
        const { subject } = this.props

        confirm(`ต้องการลบวิชา '${subject.title}' ใช่หรือไม่?`).then(
            (result) => {
                api.deleteSubject(subject.id).then(([response, json]) => {
                    if (response.status === 200) {
                        this.setState({ open: false })
                        if (this.props.onUpdateCompleted) {
                            this.props.onUpdateCompleted()
                        }
                    } else {
                        console.error('ไม่สามารถลบวิชาได้')
                    }
                }).catch(() => {
                    console.error('ไม่สามารถเชื่อมต่อ service ได้')
                })
            },
            (result) => { }
        )
    }

    toggleSubject = () => {
        const { subject } = this.props
        api.toggleSubject(subject.id).then(([response, json]) => {
            if (response.status === 200) {
                this.setState({ open: false })
                if (this.props.onUpdateCompleted) {
                    this.props.onUpdateCompleted()
                }
            } else {
                console.error('ไม่สามารถลบวิชาได้')
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
        })
    }

    componentWillMount() {
        const { title, description, level, subjectNo, departmentId } = this.props.subject
        this.setState({ title, description, level, subjectNo, departmentId })
    }

    render() {
        const { title, description, level, subjectNo, departmentId, departments } = this.state
        const { subject } = this.props
        return (
            <React.Fragment>
                <IconButton aria-label="Edit" onClick={this.handleClickOpen}>
                    <EditIcon />
                </IconButton>
                <IconButton aria-label="CheckBox" onClick={this.toggleSubject}>
                    {subject.deactivated ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </IconButton>
                <IconButton aria-label="Delete" onClick={this.deleteSubject}>
                    <DeleteIcon />
                </IconButton>

                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                >
                    <DialogTitle id="form-dialog-title">แก้ไขวิชา</DialogTitle>
                    <DialogContent>
                        <Grid container spacing={24} >
                            <Grid item xs={6}>
                                <FormControl style={{ minWidth: 240 }} fullWidth>
                                    <InputLabel htmlFor="demo-controlled-open-select">ชื่อกลุ่มวิชา</InputLabel>
                                    <Select
                                        value={departmentId}
                                        onChange={(event) => { this.setState({ departmentId: event.target.value }) }}
                                        inputProps={{
                                            name: 'department',
                                            id: 'department-simple',
                                        }}
                                    >
                                        <MenuItem value="">
                                            <em>กรุณาเลือก</em>
                                        </MenuItem>
                                        {departments.map(department => (
                                            <MenuItem value={department.id}>{department.title}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl style={{ minWidth: 240 }} fullWidth>
                                    <InputLabel htmlFor="demo-controlled-open-select">ระดับชั้น</InputLabel>
                                    <Select
                                        value={level}
                                        onChange={(event) => { this.setState({ level: event.target.value }) }}
                                        inputProps={{
                                            name: 'level',
                                            id: 'level-simple',
                                        }}
                                    >
                                        <MenuItem value="">
                                            <em>กรุณาเลือก</em>
                                        </MenuItem>
                                        <MenuItem value="ประถมศึกษา ปีที่ 1">ประถมศึกษา ปีที่ 1</MenuItem>
                                        <MenuItem value="ประถมศึกษา ปีที่ 2">ประถมศึกษา ปีที่ 2</MenuItem>
                                        <MenuItem value="ประถมศึกษา ปีที่ 3">ประถมศึกษา ปีที่ 3</MenuItem>
                                        <MenuItem value="ประถมศึกษา ปีที่ 4">ประถมศึกษา ปีที่ 4</MenuItem>
                                        <MenuItem value="ประถมศึกษา ปีที่ 5">ประถมศึกษา ปีที่ 5</MenuItem>
                                        <MenuItem value="ประถมศึกษา ปีที่ 6">ประถมศึกษา ปีที่ 6</MenuItem>
                                        <MenuItem value="มัธยมศึกษา ปีที่ 1">มัธยมศึกษา ปีที่ 1</MenuItem>
                                        <MenuItem value="มัธยมศึกษา ปีที่ 2">มัธยมศึกษา ปีที่ 2</MenuItem>
                                        <MenuItem value="มัธยมศึกษา ปีที่ 3">มัธยมศึกษา ปีที่ 3</MenuItem>
                                        <MenuItem value="มัธยมศึกษา ปีที่ 4">มัธยมศึกษา ปีที่ 4</MenuItem>
                                        <MenuItem value="มัธยมศึกษา ปีที่ 5">มัธยมศึกษา ปีที่ 5</MenuItem>
                                        <MenuItem value="มัธยมศึกษา ปีที่ 6">มัธยมศึกษา ปีที่ 6</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="subjectNo"
                                    name="subjectNo"
                                    label="รหัสวิชา"
                                    fullWidth
                                    value={subjectNo}
                                    onChange={(event) => { this.setState({ subjectNo: event.target.value }) }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="title"
                                    name="title"
                                    label="ชื่อวิชา"
                                    fullWidth
                                    value={title}
                                    onChange={(event) => { this.setState({ title: event.target.value }) }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="description"
                                    name="description"
                                    label="รายละเอียด"
                                    fullWidth
                                    multiline
                                    rows={6}
                                    value={description}
                                    onChange={(event) => { this.setState({ description: event.target.value }) }}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            ยกเลิก
                        </Button>
                        <Button onClick={this.updateSubject} color="primary">
                            บันทึก
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

export default Editor;